import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import RevealText from "./RevealText";
import "../assets/styles/MainScrollText.css";

gsap.registerPlugin(ScrollTrigger);

function MainScrollText({ data }) {
  useEffect(() => {
    // Initialize Lenis for smooth scrolling
    const lenis = new Lenis();

    // Update ScrollTrigger on Lenis scroll
    lenis.on("scroll", ScrollTrigger.update);

    // Configure ScrollTrigger to use Lenis as the scroller
    ScrollTrigger.scrollerProxy(document.body, {
      scrollTop(value) {
        if (arguments.length) {
          lenis.scrollTo(value);
          return;
        }
        return lenis.scroll;
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight,
        };
      },
      pinType: document.body.style.transform ? "transform" : "fixed",
    });

    // Animation frame loop for Lenis
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Cleanup on unmount
    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div
      className={` ${data.className} flex justify-center items-center flex-col space-y-28 font-system`}
    >
      <section className={`${data.fontSize} scroll-text-content font-medium`}>
        <RevealText
          text={data.text}
          bgColor={data.bgColor}
          fgColor={data.fgColor}
          forward={data.forward}
        />
      </section>
      <section className={`${data.authorColor} text-center font-mono`}>
        <h1 className="font-bold uppercase">{data.author}</h1>
        <p>{data.position}</p>
      </section>
    </div>
  );
}

export default MainScrollText;
